import React, {useState} from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css'; 
import 'slick-carousel/slick/slick-theme.css';

// const settings = {
//   dots: false,
//   infinite: false,
//   speed: 500,
//   slidesToShow: 3,
//   slidesToScroll: 1,
// };
const articles = [
    {
      id: 1,
      title: "Shockproofing the Tourism Economy Through Technology",
      date: "13-Jan-2025",
      description: "Learn how technology boosts tourism with AI, analytics, and...",
      image: "https://picsum.photos/400/250?random=1",
      link: "#",
    },
    {
      id: 2,
      title: "Regulatory Frameworks for Digital Identity",
      date: "20-Sep-2024",
      description: "Regulatory Frameworks for Digital Identity with Global Perspectives...",
      image: "https://picsum.photos/400/250?random=1",
      link: "#",
    },
    {
      id: 3,
      title: "Building a Secure Digital Space",
      date: "19-Dec-2023",
      description: "A profound understanding of the evolving threat landscape and the...",
      image: "https://picsum.photos/400/250?random=1",
      link: "#",
    },
  ];

  const slides = [
    {
      title: 'Microfinance',
      description: 'We help poor communities create savings and lending groups.',
      stats: [
        { label: 'Participants', value: '3M' },
        { label: 'Projects', value: '85' },
        { label: 'Countries', value: '45' },
      ],
      image: 'https://picsum.photos/400/250?random=1', // Use local or external image
      icon: '💰',
    },
    {
      title: 'Programming Approaches & Support',
      description: 'We deliver programs that are effective, responsive, and grounded.',
      stats: [],
      image: 'https://picsum.photos/400/250?random=2',
      icon: '📣',
    },
    {
      title: 'Water Security',
      description: 'We work to ensure that all communities live in a water-secure world.',
      stats: [
        { label: 'Participants', value: '9M' },
        { label: 'Projects', value: '96' },
        { label: 'Countries', value: '39' },
      ],
      image: 'https://picsum.photos/400/250?random=3',
      icon: '🚰',
    },
  ];
  
  const newsData = [
    {
      date: "16 OCT 2025",
      region: "Finland",
      title:
        "Finland: One in five children unintentionally exposed to content about suicide and war online",
      summary:
        "Save the Children’s surveyed over 1,000 Finnish 9–15-year-olds about their experiences of online harm...",
      image: "https://picsum.photos/400/250?random=1",
      link: "/news/finland-children-exposure",
    },
    {
      date: "16 OCT 2025",
      region: "Global",
      title: "Conflict plunged 63 million children into hunger in 2025",
      summary:
        "Of the around 118 million children plunged into hunger so far in 2025, around 63 million were due to conflict...",
      image: "https://picsum.photos/400/250?random=2",
      link: "/news/children-hunger-2025",
    },
    {
      date: "15 OCT 2025",
      region: "Global",
      title:
        "Number of Rohingya refugees leaving Bangladesh by boat tripled in first half of 2025, including at least 87 children",
      summary:
        "Reduced funding, which has led to cuts in essential services like education and health, is forcing families to flee...",
      image: "https://picsum.photos/400/250?random=3",
      link: "/news/rohingya-refugees-2025",
    },
    {
        date: "16 OCT 2025",
        region: "Finland",
        title:
          "Finland: One in five children unintentionally exposed to content about suicide and war online",
        summary:
          "Save the Children’s surveyed over 1,000 Finnish 9–15-year-olds about their experiences of online harm...",
        image: "https://picsum.photos/400/250?random=1",
        link: "/news/finland-children-exposure",
      },
      {
        date: "16 OCT 2025",
        region: "Global",
        title: "Conflict plunged 63 million children into hunger in 2025",
        summary:
          "Of the around 118 million children plunged into hunger so far in 2025, around 63 million were due to conflict...",
        image: "https://picsum.photos/400/250?random=2",
        link: "/news/children-hunger-2025",
      },
      {
        date: "15 OCT 2025",
        region: "Global",
        title:
          "Number of Rohingya refugees leaving Bangladesh by boat tripled in first half of 2025, including at least 87 children",
        summary:
          "Reduced funding, which has led to cuts in essential services like education and health, is forcing families to flee...",
        image: "https://picsum.photos/400/250?random=3",
        link: "/news/rohingya-refugees-2025",
      },
  ];
  
  const ArticlesSection = () => {

    const settings = {
        dots: false,
        infinite: false,
        speed: 600,
        slidesToShow: 3,
        slidesToScroll: 1,
        centerPadding: "60px",
        responsive: [
          {
            breakpoint: 1024,
            settings: { slidesToShow: 1 },
          },
        ],
      };

    return (
        <section className="news-slider-section">
      <h2 className="section-title">Latest News</h2>
      <Slider {...settings}>
        {newsData.map((news, index) => (
            // <div key={index} className="slide-wrapper">
          <div className="news-card" key={index}>
            <div
              className="news-image"
              style={{ backgroundImage: `url(${news.image})` }}
            ></div>
            <div className="news-content">
              <span className="news-meta">
                {news.date} | <span className="news-region">{news.region}</span>
              </span>
              <h3 className="news-title">{news.title}</h3>
              <p className="news-summary">{news.summary}</p>
              <a href={news.link} className="read-more">
                Read more →
              </a>
            </div>
            {/* </div> */}
          </div>
        ))}
      </Slider>
    </section>
  );
  }

// const ArticlesSection = () => {

// return(<Slider {...settings}>
//   {articles.map(()=>(<SingleArticlesSection/>))}
// </Slider>)
// }

  export default ArticlesSection